/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'


export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        // todo: moduleTodo,
        // calendar: moduleCalendar,
        // chat: moduleChat,
        // email: moduleEmail,
        auth: moduleAuth,
        eCommerce: moduleECommerce
    },
    strict: process.env.NODE_ENV !== 'production',
    forms: [],
    activeForm: [],
    activeTabForFields: 'elements',
    themingVars: {
        globalFontFamily: "Arial",
        globalFontColor: "#777777",
        globalLinkColor: "#206C92",
        globalFontSize: "16",

        labelFontWeight: "500",
        labelFontSize: "16",
        labelMarginBottom: "10",

        helpTextColor: "#cccccc",
        helpTextFontSize: "12",
        helpTextMarginTop: "10",


        inputBorderRadius: "4",
        inputBorderColor: "#dcdfe6",
        inputHoverBorderColor: "#c0c4cc",
        inputFocusBorderColor: "#000000",
        inputShadowColor: "#9D9D9D",

        buttonBackground: "#000000",
        buttonBorderColor: "#000000",
        buttonColor: "#FFFFFF"
    }
})